type Service =
  "coin" | "crown" | "dice" | "identity" | "offer" | "stitch" | "trolley"

type ServiceMap = Map<
  Service,
  {
    dev: string
    stg: string
    prd: string
  }
>

type STAGE_NAME = "prd" | "stg" | "dev"

const VERCEL_ENV_MAP: Record<string, STAGE_NAME> = {
  production: "prd",
  preview: "stg",
  development: "dev",
}

const vercelEnv =
  process.env.NEXT_PUBLIC_VERCEL_ENV ?? process.env.VERCEL_ENV ?? ""

export const STAGE: STAGE_NAME =
  process.env.NODE_ENV === "development"
    ? "dev"
    : (VERCEL_ENV_MAP[vercelEnv] ?? "prd")

export const IS_PRODUCTION = STAGE === "prd"

const productionUrl = (
  process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL ??
  process.env.VERCEL_PROJECT_PRODUCTION_URL
)?.replace("https://", "")

const deploymentUrl = (
  process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL ?? process.env.VERCEL_URL
)?.replace("https://", "")

export const APP_URL =
  STAGE === "prd" && productionUrl
    ? `https://${productionUrl}`
    : deploymentUrl
      ? `https://${deploymentUrl}`
      : STAGE === "dev"
        ? "https://localhost:3001"
        : productionUrl
          ? `https://${productionUrl}`
          : ""

export const ENDPOINTS: ServiceMap = new Map([
  [
    "coin",
    {
      dev: "https://coin.stg.div.haus",
      stg: "https://coin.stg.div.haus",
      prd: "https://coin.div.haus",
    },
  ],
  [
    "crown",
    {
      dev: "https://crown.stg.div.haus",
      stg: "https://crown.stg.div.haus",
      prd: "https://crown.div.haus",
    },
  ],
  [
    "dice",
    {
      dev: "https://dice.stg.div.haus",
      stg: "https://dice.stg.div.haus",
      prd: "https://dice.div.haus",
    },
  ],
  [
    "trolley",
    {
      dev: "https://trlly.stg.div.haus",
      stg: "https://trlly.stg.div.haus",
      prd: "https://trlly.div.haus",
    },
  ],
  [
    "identity",
    {
      // The identity service's local dev port (store dev runs on 3001). MUST
      // be https: store dev serves https://localhost:3001, so an http endpoint
      // is blocked as active mixed content and every Identity call fails.
      dev: "https://localhost:3000",
      // stg lives on baerskin.dev so the staging storefront and the Vercel
      // preview hosts (*.baerskin.dev) are same-site with it and the session
      // cookie works there.
      stg: "https://id.baerskin.dev",
      prd: "https://id.baerskintactical.com",
    },
  ],
  [
    "offer",
    {
      dev: "https://offer.stg.div.haus",
      stg: "https://offer.stg.div.haus",
      prd: "https://offer.div.haus",
    },
  ],
  [
    "stitch",
    {
      dev: "https://stitch.stg.div.haus",
      stg: "https://stitch.stg.div.haus",
      prd: "https://stitch.div.haus",
    },
  ],
])

export const getServiceEndpoint = (service: Service) =>
  ENDPOINTS.get(service)?.[STAGE]
